// LoginForm.tsx
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  IconButton,
  InputAdornment,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { registerUser } from 'lib/api';
import { executeRutificator } from 'lib/api/express/enrollment';
import CustomAlert from 'lib/designSystem/Alert';
import EnhancedBox from 'lib/designSystem/BigBox';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { validaRut } from 'lib/functions/utils';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'services/redux/store';

import { Copyright } from '../../../PublicLandings/EnrolationForm';

const SigninExpress = () => {
  const [registerData, setRgisterData] = useState({
    email: '',
    password: '',
    checkPassword: '',
    name: '',
    identifier: '',
    phone: '',
    companyName: '',
  });
  const config = useSelector((state: RootState) => state.clientConfiguration);
  const companyId = config.configs.companyId;
  const [success, setSucces] = useState(false);
  const [companyNameFound, setCompanyNameFound] = useState(false);
  const domain = window.location.hostname;
  const clientId = domain.split('.')[0];
  const [loadingName, setLoadingName] = useState(false);
  const [canSeePassword, setCanSeePassword] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRgisterData({ ...registerData, [e.target.id]: e.target.value });
  };

  const handleChangeIdentifier = (value: string) => {
    if (value.includes('.')) return;
    if (value.includes(' ')) return;
    if (value.includes(',')) return;
    setRgisterData({
      ...registerData,
      identifier: value.toUpperCase(),
    });
  };

  const [loading, setLoding] = useState(false);

  const checkPassword = () => {
    if (registerData.password === registerData.checkPassword) {
      return true;
    }
    return false;
  };

  const checkPasswordLength = () => {
    if (registerData.password.length >= 12) {
      return true;
    }
    return false;
  };

  const checkParams = () => {
    if (
      registerData.email &&
      registerData.password &&
      registerData.checkPassword &&
      registerData.name &&
      registerData.identifier &&
      registerData.phone
    ) {
      return true;
    }
    return false;
  };
  const validateRut = () => {
    const rutValid = validaRut(registerData.identifier);
    if (!rutValid) {
      return false;
    } else {
      return true;
    }
  };

  const getCompanyName = async () => {
    if (!validateRut()) {
      return alert('Rut inválido');
    }
    setLoadingName(true);

    try {
      if (!clientId) return;
      const responseConsult = await executeRutificator(clientId, [
        registerData.identifier,
      ]);
      if (responseConsult) {
        setRgisterData({
          ...registerData,
          companyName:
            responseConsult.results[registerData.identifier][0].RAZON_SOCIAL,
        });
        setCompanyNameFound(true);
      } else {
        setCompanyNameFound(false);
      }
    } catch (error) {
      setCompanyNameFound(false);
    }
    setLoadingName(false);
  };

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    try {
      e.preventDefault();
      setLoding(true);
      const response = await registerUser({ ...registerData, clientId });
      if (!response.success) {
        alert(response.message);
        return setLoding(false);
      }
      setSucces(true);
    } catch (error) {
      alert('Hubo un error');
    }
    setLoding(false);
  };
  if (loading) return <CenteredCircularProgress type="dialog" />;

  const companyNameDisabled = () => {
    if (companyNameFound) return true;
    if (loadingName) return true;
    if (!registerData.identifier.length) return true;
    return false;
  };
  return (
    <div style={{ backgroundColor: '#F8FAFC', height: '100vh' }}>
      <div style={{ margin: 'auto', maxWidth: '40%', padding: 40 }}>
        <Box display="flex" justifyContent="center" alignItems="center" my={6}>
          <img
            width={250}
            src={`https://pruff-public.s3.amazonaws.com/company-logos/${companyId}.png`}
            alt="Logo"
          />
        </Box>
        <EnhancedBox>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h4">Registrarse</Typography>
            <Typography>
              <a href={`/`}>Volver</a>
            </Typography>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre personal"
                variant="outlined"
                id="name"
                value={registerData.name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(e)
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                id="email"
                value={registerData.email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(e)
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Teléfono"
                variant="outlined"
                id="phone"
                value={registerData.phone}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(e)
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Rut empresa (Sin puntos, con guión)"
                variant="outlined"
                id="identifier"
                value={registerData.identifier}
                onChange={(e) => handleChangeIdentifier(e.target.value)}
                onBlur={() => void getCompanyName()}
              />
              {!registerData.identifier.length || validateRut() ? null : (
                <Typography variant="body1" color="error">
                  Rut inválido
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre empresa"
                variant="outlined"
                id="companyName"
                value={registerData.companyName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(e)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {loadingName && <CircularProgress size={20} />}
                    </InputAdornment>
                  ),
                }}
                disabled={companyNameDisabled()}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Contraseña"
                fullWidth
                type={canSeePassword ? 'text' : 'password'}
                variant="outlined"
                value={registerData.password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(e)
                }
                id="password"
                autoComplete="new-password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setCanSeePassword(!canSeePassword)}
                      >
                        {canSeePassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Repetir contraseña"
                fullWidth
                type={canSeePassword ? 'text' : 'password'}
                variant="outlined"
                value={registerData.checkPassword}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(e)
                }
                id="checkPassword"
                autoComplete="new-password"
              />
              {checkPassword() || !registerData.checkPassword.length ? null : (
                <Typography variant="body1" color="error">
                  Las contraseñas no coinciden
                </Typography>
              )}
              {checkPasswordLength() ||
              !registerData.checkPassword.length ? null : (
                <Typography variant="body1" color="error">
                  Las contraseñas debe ser mayor a 12 caracteres
                </Typography>
              )}
            </Grid>
          </Grid>
          <Box sx={{ mt: 2 }}>
            <CustomButton
              onClick={(e) => handleSubmit(e)}
              fullWidth
              color="primary"
              variant="contained"
              disabled={
                !checkParams() ||
                !checkPassword() ||
                !validateRut() ||
                !checkPasswordLength()
              }
            >
              Registrarse
            </CustomButton>
          </Box>
        </EnhancedBox>
      </div>
      <CustomAlert
        open={success}
        setOpen={setSucces}
        severity="success"
        text="Se te envió un email para activar tu cuenta"
        onClose={() => (window.location.href = `/`)}
      />
      <Copyright />
    </div>
  );
};

export default SigninExpress;
